/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Circle, Path, Rect } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M6 7a5 5 0 0 0-5 5v0a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5v-.5",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.13 12.5a2.8 2.8 0 0 0-2.65 1.8s.85-.59 2.65-.59 2.59.6 2.59.6-.54-1.81-2.59-1.81",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Circle, {
                cx: 4.49,
                cy: 10.57,
                r: 0.5,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.67,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Circle, {
                cx: 7.51,
                cy: 10.57,
                r: 0.5,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.67,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 7,
                y: 1,
                width: 10,
                height: 10,
                rx: 5,
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Circle, {
                cx: 10.49,
                cy: 4.57,
                r: 0.5,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.67,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Circle, {
                cx: 13.51,
                cy: 4.57,
                r: 0.5,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.67,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.04 7.16c1.74.04 2.6-.55 2.6-.55s-.58 1.8-2.62 1.75C9.98 8.32 9.39 6.5 9.39 6.5s.83.62 2.65.66",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
